import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle-filled",
  "use": "icon-check-circle-filled-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-check-circle-filled\">\n  <path d=\"M24,48A24,24,0,0,1,7.029,7.029,24,24,0,0,1,40.97,40.97,23.842,23.842,0,0,1,24,48ZM13.039,23.581a1.488,1.488,0,0,0-1.059.439,1.5,1.5,0,0,0-.078,2.032l7.346,8.57a1,1,0,0,0,1.513.006L36.11,17.021a1.454,1.454,0,0,0-.068-1.978,1.449,1.449,0,0,0-2.067.017L20.681,28.8a1,1,0,0,1-1.4.037l-5.225-4.852A1.492,1.492,0,0,0,13.039,23.581Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol